import { Box, DashboardModule } from '@domain-group/suit-theme'

// @ts-expect-error TS2307
import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import PublicationProduct from './PublicationProduct'

interface PublicationProductsProps {
  assignLayoutTemplatePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const PublicationProducts = (props: PublicationProductsProps) => {
  const { assignLayoutTemplatePermissionsPayload } = props

  return (
    <DashboardModule title="Publication Products">
      <Box flexDirection="column" padding="large">
        <EntityFilters assignLayoutTemplatePermissionsPayload={assignLayoutTemplatePermissionsPayload} />

        <EntityList
          assignLayoutTemplatePermissionsPayload={assignLayoutTemplatePermissionsPayload}
          entityKey="publicationProductIds"
          // @ts-expect-error TS2322
          entityListItemComponent={PublicationProduct}
        />
      </Box>
    </DashboardModule>
  )
}

export default PublicationProducts
